package studio.goodegg.capsule.subscriptions

import com.slack.circuit.runtime.CircuitUiEvent

sealed class SubscriptionsUiEvent : CircuitUiEvent {
    data class Open(val slug: String) : SubscriptionsUiEvent()

    data class Remove(val slug: String) : SubscriptionsUiEvent()
}
